export default "__VITE_ASSET__CeEl7Ji7__"